"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _condition = _interopRequireDefault(require("./condition"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createJourneySection = function createJourneySection(_ref) {
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    title: (0, _utils.getProp)(fields, 'title'),
    conditions: (0, _utils.getProp)(fields, 'conditions') ? fields.conditions.map(function (condition) {
      return (0, _condition["default"])(condition);
    }) : null
  };
};
var _default = createJourneySection;
exports["default"] = _default;